import { config } from '@/config';

export function IFrameTest() {
  const url = 'http://' + config().FRONT_BASE_URL;
  return (
    <iframe
      src={url}
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
      }}
    />
  );
}